import { useMutation, useQueryClient } from '@tanstack/react-query';
import { uploadVerdicts } from 'services/api/NumberRegistrationAPI';

export interface UploadVerdictsParams {
    file: File;
}

export const useUploadVerdicts = () => {
    const queryClient = useQueryClient();

    const { mutateAsync, isPending } = useMutation({
        mutationFn: ({ file }: UploadVerdictsParams) => uploadVerdicts(file),
        onSuccess: () => {
            // An ingest can propose new releases for any tenant, so every
            // tenant's proposals list is stale the moment this returns.
            queryClient.invalidateQueries({ queryKey: ['releaseProposals'] });
        },
    });

    return { uploadVerdicts: mutateAsync, isUploadingVerdicts: isPending };
};
